module.exports = __webpack_public_path__ + "iron-storage-and-serum.6be080305da090f8352349fe6efc2f9b.png";